import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const colorSchemes = [
  { name: 'blue', label: 'Blue' },
  { name: 'green', label: 'Green' },
  { name: 'purple', label: 'Purple' },
  { name: 'red', label: 'Red' },
];

const fontSizes = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
];

export default function ThemeSettings() {
  const { theme, colorScheme, fontSize, toggleTheme, setColorScheme, setFontSize } = useTheme();

  return (
    <div className="card">
      <h3 className="text-xl font-semibold mb-4">Appearance Settings</h3>
      
      <div className="space-y-4">
        {/* Theme Toggle */}
        <div className="flex items-center justify-between">
          <span>Dark Mode</span>
          <button
            onClick={toggleTheme}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
              theme === 'dark' ? 'theme-bg' : 'bg-gray-200'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                theme === 'dark' ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>

        {/* Color Scheme */}
        <div className="space-y-2">
          <span>Color Scheme</span>
          <div className="grid grid-cols-4 gap-2">
            {colorSchemes.map(({ name, label }) => (
              <button
                key={name}
                onClick={() => setColorScheme(name)}
                className={`p-2 rounded-md text-sm ${
                  colorScheme === name
                    ? 'theme-bg text-white'
                    : 'bg-gray-100 dark:bg-gray-700'
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Font Size */}
        <div className="space-y-2">
          <span>Font Size</span>
          <div className="grid grid-cols-3 gap-2">
            {fontSizes.map(({ value, label }) => (
              <button
                key={value}
                onClick={() => setFontSize(value)}
                className={`p-2 rounded-md text-sm ${
                  fontSize === value
                    ? 'theme-bg text-white'
                    : 'bg-gray-100 dark:bg-gray-700'
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
} 